var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TimeUi,{ref:"timeFromField",staticClass:"time-from",attrs:{"label":"с","time":_setup.props.timeFrom,"disabled":_setup.props.disabled,"availableTimes":_setup.props.availableTimes,"invalid":_vm.invalid},on:{"update:time":function($event){return _setup.emit('update:timeFrom', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }